import FlexibleData from '@lib/cms/flexibleData';
import { fetchAssociatedAgent, getAssociatedAgentItem } from '@lib/associatedAgent';
import BuilderDevelopmentTemplate from '@templates/BuilderDevelopment';

export async function getServerSideProps(context) {
  const preview = context.preview || false;
  const { agentid } = context.query;
  let associatedAgent = null;

  const previewEnv = context?.previewData?.environment || null;
  const data = await FlexibleData.fetchBuilderDevelopmentPage(
    'Builder',
    context.params.slug,
    preview,
    previewEnv
  );

  if (agentid && data?.allAgentPermission) {
    associatedAgent = await fetchAssociatedAgent({ agentId: parseInt(agentid) });
  }

  return {
    props: { data, preview, associatedAgent: getAssociatedAgentItem(associatedAgent) }
  };
}

const BuilderPage = ({ data, preview, associatedAgent }) => {
  return (
    <BuilderDevelopmentTemplate data={data} preview={preview} associatedAgent={associatedAgent} />
  );
};

export default BuilderPage;
